module.exports = __webpack_public_path__ + "static/media/CBERS 4.cca06076.czml";